<template>
    <div class="widget-item pim-informational">
        <div class="widget-body">
            <div class="row">
                <div class="col plan-details">
                    <div class="sub-icon">
                        <img v-if="loggedInPlanDetails.planIcon != ''" :src="loggedInPlanDetails.planIcon" alt="">
                        <img v-else src="/images/logo-plan-tier-0.svg" alt="">
                    </div>
                    <div class="sub-title">
                        <strong>Name:</strong> {{loggedInPlanDetails.pimName}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import moment from 'moment';

    Vue.use(VueEvents)

    export default {
        name: 'widget-plan-details',
        props: [
            'planDetails'
        ],
        data() {
            return {
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                uiStates: {
                    showLoading: true,
                },
                loggedInPlanDetails: this.planDetails,
            }
        },
    };
</script>

<style lang="scss">
    .pim-informational{
        .plan-details{
            border-right: 1px solid #F1F2F2;
            .sub-icon{
                padding-top:25px;
                padding-bottom:10px;
                text-align: center;
                img{
                    width:100px;
                }
            }
            .sub-title{
                font-size: 20px;
                color: #7D7D7D;
                text-align: center;
                margin-bottom:25px;
            }
        }
        .remaing-skus{
            text-align: center;
            padding-top:47px;
            font-size: 18px;
            color: #1F2529;

        }
        .widget-number{
            padding-top: 0px;
            margin-top: -10px;
            font-size: 50px;
            color: #9D9B9B;
            text-align: center;
        }
    }
</style>
